// import React from "react";

// export default function StepsTimeline({ points }) {
//   const totalPoints = points.length;
//   const startX = 80;
//   const endX = 1080;
//   const pathWidth = endX - startX;
//   const xGap = pathWidth / (totalPoints - 1);

//   return (
//     <div style={styles.timelineWrapper}>
//       <svg viewBox="0 0 1200 220" style={styles.timelineSvg}>
//         {/* Straight dashed line */}
//         <path
//           d={`M${startX} 100 L${endX} 100`}
//           stroke="#cfcfcf"
//           strokeWidth="2"
//           strokeDasharray="4,4"
//           fill="transparent"
//         />
//       </svg>

//       {/* Steps */}
//       <div style={styles.timelineSteps}>
//         {points.map((text, index) => (
//           <div
//             key={index}
//             style={{
//               ...styles.timelineStep,
//               top: index % 2 === 0 ? "60px" : "140px",
//               left: `${startX + index * xGap}px`,
//             }}
//           >
//             <div style={styles.circle}>{index + 1}</div>
//             <p style={styles.label}>{text}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// const styles = {
//   timelineWrapper: {
//     position: "relative",
//     width: "100%",
//     maxWidth: "1164px",
//     margin: "80px auto 0 auto",
//     height: "220px",
//   },
//   timelineSvg: {
//     width: "100%",
//     height: "220px",
//     position: "absolute",
//     top: 0,
//     left: 0,
//   },
//   timelineSteps: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "220px",
//   },
//   timelineStep: {
//     position: "absolute",
//     textAlign: "center",
//     transform: "translateX(-50%)",
//   },
//   circle: {
//     width: "34px",
//     height: "34px",
//     borderRadius: "50%",
//     backgroundColor: "#f5f5f5",
//     color: "#333",
//     fontWeight: "600",
//     fontSize: "15px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     margin: "0 auto 8px",
//     border: "1.5px solid #ddd",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//   },
//   label: {
//     fontSize: "14px",
//     color: "#333",
//     fontWeight: "500",
//     whiteSpace: "nowrap",
//   },
// };
import React from "react";

const StepsTimeline = () => {
  const steps = [
    { id: 1, title: "Safe & Reliable" },
    { id: 2, title: "Quick Approvals" },
    { id: 3, title: "Flexible Loan Options" },
    { id: 4, title: "Transparent Process" },
    { id: 5, title: "Secure & Confidential" },
    { id: 6, title: "Dedicated Support" },
  ];

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      maxWidth: "1100px",
      margin: "120px auto",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    line: {
      position: "absolute",
      top: "50%",
      left: "8%",
      right: "8%",
      borderTop: "2px dotted #d1d5db",
      transform: "translateY(-50%)",
      zIndex: 1,
    },
    step: {
      position: "relative",
      flex: 1,
      textAlign: "center",
      zIndex: 2,
    },
    stepContent: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      justifyContent: "center",
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
    },
    circle: {
      width: "34px",
      height: "34px",
      backgroundColor: "#f3f4f6",
      borderRadius: "50%",
      border: "1px solid #e5e7eb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#555",
      fontSize: "14px",
      fontWeight: 500,
      zIndex: 2,
    },
    label: {
      color: "#333",
      fontSize: "14px",
      fontWeight: 400,
      whiteSpace: "nowrap",
    },
    connector: {
      position: "absolute",
      left: "50%",
      width: "2px",
      height: "60px",
      transform: "translateX(-50%)",
      borderLeft: "2px dotted #d1d5db",
    },
    topStepContent: { bottom: "calc(50% + 80px)" },
    bottomStepContent: { top: "calc(50% + 80px)" },
    topConnector: { bottom: "50%" },
    bottomConnector: { top: "50%" },
    firstConnectorCurve: {
      width: "60px",
      height: "60px",
      border: "2px dotted #d1d5db",
      borderBottom: "none",
      borderRight: "none",
      borderTopLeftRadius: "60px",
      background: "none",
      position: "absolute",
      left: "8%",
      bottom: "50%",
      transform: "translateY(0)",
    },
  };

  return (
    <div style={styles.container}>
      {/* Central Line */}
      <div style={styles.line}></div>

      {steps.map((step, index) => {
        const isTop = index % 2 === 0;
        const isFirst = index === 0;

        return (
          <div key={step.id} style={styles.step}>
            {/* Connector */}
            <div
              style={
                isFirst
                  ? styles.firstConnectorCurve
                  : {
                      ...styles.connector,
                      ...(isTop
                        ? styles.topConnector
                        : styles.bottomConnector),
                    }
              }
            ></div>

            {/* Circle and Label */}
            <div
              style={{
                ...styles.stepContent,
                ...(isTop
                  ? styles.topStepContent
                  : styles.bottomStepContent),
              }}
            >
              <div style={styles.circle}>{step.id}</div>
              <div style={styles.label}>{step.title}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepsTimeline;
